<template>
  <label class="checkbox-label" :class="isMobile()?'mobile-label':''">
    {{label}}
    <input type="checkbox" @click="onClick()" :checked="value" :disabled="disabled" />
    <span :class="IsRadio?'radio-checkmark':'checkbox-checkmark'" :style="getStyle()"></span>
  </label>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Checkbox",
  props: {
    label: {
      type: String,
      default: "label"
    },
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    IsRadio: {
      type: Boolean,
      default: false
    }
  },
  mounted: function() {
    this.$el.indeterminate = true;
  },
  computed: {
    ...mapGetters(["desktopStyles", "mobileStyles"])
  },
  methods: {
    onClick() {
      switch (this.value) {
        case null:
          this.$emit("change", true);
          this.$emit("input", true);
          break;
        case true:
          this.$emit("change", false);
          this.$emit("input", false);
          break;
        case false:
          this.$emit("change", true);
          this.$emit("input", true);
          break;
      }
    },
    getStyle() {
      var style = [];
      if (this.value) {
        style.push(
          this.isMobile()
            ? this.mobileStyles.CommonColorBackground
            : this.desktopStyles.CommonColorBackground
        );
      } else {
        style.push(
          this.isMobile()
            ? this.mobileStyles.pendingStatusBackground
            : this.desktopStyles.pendingStatusBackground
        );
      }
      return style;
    }
  }
};
</script>